import { Context, createContext } from 'react';

import { IPaginationStore } from './types';

export class PaginationStore {
  public context: Context<IPaginationStore>;

  constructor(
    initialContext: IPaginationStore = {
      currPage: 0,
      showAll: false,
    }
  ) {
    this.context = createContext(initialContext);
  }
}
export const PaginationContext = new PaginationStore().context;
export default PaginationContext;
